import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'UI/res';
import { isDarkTheme } from 'UI/theme/darkTones';

export const styles = {
  truncateText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 400
  },
  cardSubheader: {
    margin: '20px 0'
  },
  drawerContainer: {
    backgroundColor: colors.white,
    padding: 0
  },
  visibilityNotificationNoActive: { backgroundColor: colors.borderColor, color: colors.darkGrey }
};

/**
 * Style of the selected visibility chip (Unread / Read / All). Light keeps its original lavender
 * chip; dark uses primary tokens so the chip does not glow on the dark drawer.
 * @param {Object} theme MUI theme
 * @returns {{ backgroundColor: string, color: string }}
 */
export const getActiveVisibilityChipStyle = theme =>
  isDarkTheme(theme)
    ? { backgroundColor: theme.palette.primary.FP200, color: theme.palette.primary.light }
    : { backgroundColor: '#C8CFFC', color: '#5A6DF5' };

const stylesCard = {
  width: '100%',
  maxHeight: 120,
  display: 'flex',
  position: 'relative',
  boxShadow:
    '0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 1px rgba(0,0,0,0.12)',
  borderRadius: 0
};

export const useStyles = makeStyles(theme => ({
  root: {
    ...stylesCard,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey[200],
      width: '100%'
    }
  },
  read: {
    ...stylesCard,
    opacity: 0.5,
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.grey[50],
      width: '100%'
    }
  },
  leftIndicator: {
    width: 6,
    height: '100%',
    position: 'absolute',
    backgroundColor: props => props.indicatorColor
  },
  iconContainer: {
    padding: 0
  },
  icon: {
    position: 'absolute',
    left: 30
  },
  textContainer: {
    marginLeft: 60
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    maxHeight: '2.4em',
    ...ellipsis
  },
  body: {
    fontWeight: theme.typography.fontWeightLight,
    maxHeight: '2.4em',
    ...ellipsis
  },
  created: {
    fontWeight: theme.typography.fontWeightLight,
    maxHeight: '1.4em',
    color: props => props.createdColor
  },
  indicatorContainer: {
    padding: 0
  },
  indicator: {
    position: 'absolute',
    right: 20
  },
  visibilityNotifications: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5)
    }
  },
  deniedTitle: {
    color: theme.palette.error.main,
    maxWidth: '100%',
    fontSize: 14,
    margin: theme.spacing(1)
  },
  grantedTitle: {
    color: theme.palette.primary.main,
    maxWidth: '100%',
    fontSize: 14,
    margin: theme.spacing(1)
  }
}));

const ellipsis = {
  overflow: 'hidden',
  position: 'relative',
  lineHeight: '1.3em',
  marginRight: '-1em',
  paddingRight: '1em'
};
